import { render } from "./kgo_remaining-card.vue?vue&type=template&id=71bb08d9&scoped=true"
import script from "./kgo_remaining-card.vue?vue&type=script&lang=js"
export * from "./kgo_remaining-card.vue?vue&type=script&lang=js"

import "./kgo_remaining-card.vue?vue&type=style&index=0&id=71bb08d9&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71bb08d9"]])

export default __exports__